<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 886.000000 737.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,737.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path d="M5930 7363 c-385 -13 -835 -46 -1160 -84 -1824 -212 -4141 -922
                -4640 -1421 -73 -73 -111 -147 -117 -232 -10 -121 55 -266 166
                -369 121 -113 170 -118 1311 -122 1079 -4 1440 -20 1713 -76 102
                -20 210 -56 205 -68 -7 -14 -603 -754 -694 -861 -132 -155 -327
                -349 -394 -393 -42 -28 -104 -51 -260 -96 -650 -190 -1067 -379
                -1259 -572 -85 -85 -126 -171 -126 -264 1 -52 6 -80 22 -110 42
                -79 130 -139 183 -126 39 11 63 63 68 153 l5 79 75 55 c165 120
                382 223 667 317 183 61 377 118 382 113 2 -1 -64 -144 -146 -317
                -519 -1097 -817 -1872 -849 -2205 -29 -302 87 -621 267 -736 51
                -32 82 -35 106 -11 21 21 15 85 -15 143 -72 141 -70 357 6 639 92
                337 258 730 559 1318 311 607 584 1077 739 1269 68 85 113 112
                251 147 374 97 1013 175 1464 178 134 1 207 11 228 32 10 9 18 39
                21 72 4 51 2 59 -24 86 -51 53 -167 77 -429 88 -315 14 -722 -9
                -953 -52 l-71 -14 29 42 c55 80 243 321 362 463 357 426 776 848
                1053 1058 284 216 513 308 615 247 74 -43 88 79 25 212 -33 68
                -106 150 -158 177 -72 36 -173 9 -396 -108 -264 -137 -735 -478
                -1107 -801 -34 -29 -66 -53 -71 -53 -5 0 -20 12 -34 26 -79 86
                -257 190 -415 242 -301 101 -847 152 -1625 152 -371 0 -929 12
                -929 21 0 12 340 180 551 273 461 202 792 320 1349 481 999 288
                2122 497 3110 579 410 34 553 40 1010 40 983 1 1545 -87 1877
                -296 46 -29 129 -95 183 -145 142 -132 177 -134 187 -10 7 83 -13
                144 -76 234 -74 105 -204 217 -353 304 -336 196 -1148 313 -2128
                307 -157 -1 -319 -3 -360 -5z"
        />
      </g>
    </svg>
  </div>
</template>

<script setup>
</script>